import type { FC } from "react";
import type { ModalProps } from "@uhg-harmony/react";
import { BaseConfirmationModal } from "./BaseConfirmationModal";

type LibraryConfirmationModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onContinue?: () => void;
};

export const LibraryConfirmationModal: FC<LibraryConfirmationModalProps> = ({
  title = "Unsaved Changes",
  open,
  onClose,
  onContinue,
}) => (
  <BaseConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onContinue}
    title={title}
    bodyText="You have unsaved changes. Do you want to save as draft before continuing to the Template Library?"
    confirmLabel="Continue Without Saving"
    confirmVariant="destructive"
  />
);
